export const FETCH_GROUPS_REQUEST = "fetch/groups/request";
export const FETCH_GROUPS_SUCCESS = "fetch/groups/success";
export const FETCH_GROUPS_FAILURE = "fetch/groups/failure";

export const FETCH_ADOPTIONS_REQUEST = "fetch/adoptions/request";
export const FETCH_ADOPTIONS_SUCCESS = "fetch/adoptions/success";
export const FETCH_ADOPTIONS_FAILURE = "fetch/adoptions/failure";

export const FETCH_ASSETS_REQUEST = "fetch/assets/request";
export const FETCH_ASSETS_SUCCESS = "fetch/assets/success";
export const FETCH_ASSETS_FAILURE = "fetch/assets/failure";

export const ACTIVATE_ASSET_REQUEST = "activate/asset/request";
export const ACTIVATE_ASSET_SUCCESS = "activate/asset/success";
export const ACTIVATE_ASSET_FAILURE = "activate/asset/failure";
export const SYNC_ACTIVATE_ASSET_SUCCESS = "sync/activate/asset/success";

export const RETURN_ASSET_REQUEST = "return/asset/request";
export const RETURN_ASSET_SUCCESS = "return/asset/success";
export const RETURN_ASSET_FAILURE = "return/asset/failure";
export const SYNC_RETURN_ASSET_SUCCESS = "sync/return/asset/success";

export const ACTIVATE_PROMOTION_REQUEST = "activate/promotion/request";
export const ACTIVATE_PROMOTION_SUCCESS = "activate/promotion/success";
export const ACTIVATE_PROMOTION_FAILURE = "activate/promotion/failure";

export const DEACTIVATE_PROMOTION_REQUEST = "deactivate/promotion/request";
export const DEACTIVATE_PROMOTION_SUCCESS = "deactivate/promotion/success";
export const DEACTIVATE_PROMOTION_FAILURE = "deactivate/promotion/failure";

export const FETCH_SESSION_REQUEST = "fetch/session/request";
export const FETCH_SESSION_SUCCESS = "fetch/session/success";
export const FETCH_SESSION_FAILURE = "fetch/session/failure";
export const SYNC_FETCH_SESSION_SUCCESS = "sync/fetch/session/success";

export const FETCH_SINGLE_ASSET_REQUEST = "fetch/asset/request";
export const FETCH_SINGLE_ASSET_SUCCESS = "fetch/asset/success";
export const FETCH_SINGLE_ASSET_FAILURE = "fetch/asset/failure";

export const SEARCH_BOOK_STORE_REQUEST = "search/store/request"
export const SEARCH_BOOK_STORE_COMPLETE = "search/store/complete"
export const SEARCH_BOOK_STORE_SUCCESS = "search/store/success"
export const SEARCH_BOOK_STORE_FAILURE = "search/store/failure"

export const FETCH_BRIDGE_ANCILLARIES_REQUEST =
  "fetch/bridge/ancillaries/request";
export const FETCH_BRIDGE_ANCILLARIES_SUCCESS =
  "fetch/bridge/ancillaries/success";
export const FETCH_BRIDGE_ANCILLARIES_FAILURE =
  "fetch/bridge/ancillaries/failure";
